import React from "react";
import "./styles.css";

const LaborMarket = () => {
  return (
    <div className="container">
      <h1>Labor Market</h1>
      <p>In perfect competition, both employers, and employees are price takers, and quantity adjusters. Market demand, and supply determine wages.</p>
      <p>In monopoly, an employer has the advantage of deciding who to employ, in what capacity, and at what rate.</p> 
      <p>Note that discrimination is still possible, where an employer is able to divide the workforce, so that different wages are paid to different employees of the same category, or different wages are paid to the same category of employee, but in multiple roles.</p>
      <p>Monopsony is a labor market categorized by the presence of a strong trade, or labour union, which collectively decide the wage rate, number of hours worked, and working conditions inter alia. Here the employees have an advantage of employers.</p>
      <p>In monopoly vs. monopsony, we now have the single wage monopoly employer, facing off with a trade, or labor union. The wage rate inter alia will be decided via collective bargaining.</p>
    </div>
  );
};

export default LaborMarket;